/*
 * Lernen mit Hugo — Progressive-Enhancement-Schicht (Prototyp lernen.html).
 * Ohne JS steht alles im HTML: alle Karten, Listen, Story-Folien und Download-Links.
 *  1. Filter: Suche + Hebel (alle gewählten müssen passen) + Alter (eine Auswahl)
 *     über .lern-karte[data-hebel][data-ages] im Body.
 *  2. Karten-Modal: Klick auf eine .lern-karte öffnet die Detailansicht wie im
 *     Prototyp (Seiten-Vorschau zum Blättern, Etiketten, Inhalt, Reihe, Tipp,
 *     „PDF herunterladen“). Das PDF kommt vom Shopify-CDN (CORS offen) und wird
 *     mit sprechendem Dateinamen gespeichert; schlägt das fehl, öffnet es im Tab.
 *  3. Story „Lerne Hugo kennen“: aus den .lern-story-folie wird der Vollbild-
 *     Story-Viewer (Fortschrittsbalken, Auto-Weiter, Pause, Pfeile, Tastatur).
 *     Die Bildstrecke im Body wird dann ausgeblendet (Klasse lrn-js-story).
 *  4. Guides: „Auf dieser Seite“ aus den H2 des Bodys (nav[data-lrn-toc]).
 *  5. Kita-Paket: Listenzeilen in Titel / Unterzeile / Etiketten gliedern.
 */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var roots = document.querySelectorAll('.lrn');
    for (var r = 0; r < roots.length; r++) enhance(roots[r]);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  var ICON = {
    x: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    prev: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M14.5 5.5 8 12l6.5 6.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="m9.5 5.5 6.5 6.5-6.5 6.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    pause: '<svg class="i-pause" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M8 5h3v14H8zM13 5h3v14h-3z" fill="currentColor"/></svg>',
    play: '<svg class="i-play" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z" fill="currentColor"/></svg>'
  };

  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  function toast(root, msg) {
    var t = el('div', 'lrn-toast', msg);
    t.setAttribute('role', 'status');
    root.appendChild(t);
    setTimeout(function () { t.remove(); }, 3200);
  }

  function enhance(root) {
    var cards = root.querySelectorAll('.lern-karte');
    var dl = cards.length ? setupModal(root) : null;
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (dl) {
        card.setAttribute('tabindex', '0');
        card.setAttribute('role', 'button');
        card.setAttribute('aria-haspopup', 'dialog');
        var h = card.querySelector('h3');
        if (h) card.setAttribute('aria-label', h.textContent + ': Details ansehen');
      } else {
        wrapDetails(card);
      }
    }
    if (dl) root.classList.add('lrn-js-cards');

    setupFilter(root, cards);
    setupStory(root);
    setupToc(root);
    setupPaket(root);
  }

  // Ohne Modal (sollte nicht vorkommen) klappen die Stichpunkte in <details> ein.
  function wrapDetails(card) {
    var list = card.querySelector(':scope > ul');
    if (!list) return;
    var d = el('details');
    d.appendChild(el('summary', null, 'Was drin ist'));
    list.parentNode.insertBefore(d, list);
    d.appendChild(list);
  }

  /* ── Karten-Modal ─────────────────────────────────────────────────── */
  function setupModal(root) {
    var dl = el('div', 'lrn-dl');
    dl.setAttribute('role', 'dialog');
    dl.setAttribute('aria-modal', 'true');
    dl.setAttribute('aria-labelledby', 'lrn-dl-t');
    dl.hidden = true;
    dl.innerHTML =
      '<div class="lrn-dl-backdrop" data-dl-close></div>' +
      '<div class="lrn-dl-card">' +
        '<button class="lrn-dl-x" type="button" data-dl-close aria-label="Schließen">' + ICON.x + '</button>' +
        '<div class="lrn-dl-vis"><img alt="">' +
          '<button class="lrn-dl-nav prev" type="button" aria-label="Vorherige Seite">' + ICON.prev + '</button>' +
          '<button class="lrn-dl-nav next" type="button" aria-label="Nächste Seite">' + ICON.next + '</button>' +
          '<span class="lrn-dl-count"></span></div>' +
        '<div class="lrn-dl-body">' +
          '<div class="lrn-dl-tags"></div>' +
          '<h3 id="lrn-dl-t"></h3>' +
          '<p class="lrn-dl-meta"></p>' +
          '<ul class="lrn-dl-list"></ul>' +
          '<p class="lrn-dl-serie" hidden><b></b><span></span></p>' +
          '<p class="lrn-dl-tip"><b>Tipp:</b> Auf dickeres Papier drucken — dann hält es länger.</p>' +
          '<button class="lrn-btn lrn-dl-go" type="button">PDF herunterladen</button>' +
          '<button class="lrn-dl-cancel" type="button" data-dl-close>Abbrechen</button>' +
        '</div>' +
      '</div>';
    root.appendChild(dl);

    var img = dl.querySelector('.lrn-dl-vis img');
    var prev = dl.querySelector('.lrn-dl-nav.prev');
    var next = dl.querySelector('.lrn-dl-nav.next');
    var count = dl.querySelector('.lrn-dl-count');
    var go = dl.querySelector('.lrn-dl-go');
    var cancel = dl.querySelector('.lrn-dl-cancel');
    var pages = [];
    var idx = 0;
    var card = null;

    function show(i) {
      img.hidden = !pages.length;
      if (!pages.length) return;
      idx = Math.max(0, Math.min(pages.length - 1, i));
      img.src = pages[idx];
      img.alt = pages.length > 1 ? 'Seite ' + (idx + 1) + ' von ' + pages.length : (card.querySelector('img') || {}).alt || '';
      var multi = pages.length > 1;
      prev.hidden = next.hidden = count.hidden = !multi;
      prev.disabled = idx === 0;
      next.disabled = idx === pages.length - 1;
      count.textContent = (idx + 1) + ' / ' + pages.length;
    }

    function tag(text, cls) {
      var t = el('span', 'lrn-dl-tag' + (cls ? ' ' + cls : ''), text);
      dl.querySelector('.lrn-dl-tags').appendChild(t);
    }

    function open(c) {
      card = c;
      var pdf = c.getAttribute('data-pdf');
      var status = c.getAttribute('data-status') || (c.getAttribute('data-verfuegbar') === 'bald' ? 'bald' : '');
      var h = c.querySelector('h3');
      var metaLine = c.querySelector('h3') ? c.querySelector('h3').previousElementSibling : null;
      var own = metaLine && /^In eigener Sache/.test(metaLine.textContent.trim());

      dl.querySelector('.lrn-dl-tags').innerHTML = '';
      if (status === 'neu') tag('Neu', 'is-neu');
      else if (!pdf) tag('Bald', 'is-soon');
      else tag('Gratis', 'is-free');
      if (own) tag('In eigener Sache');
      if (c.getAttribute('data-fmt')) tag(c.getAttribute('data-fmt'));
      if (c.getAttribute('data-age')) tag(c.getAttribute('data-age'));

      dl.querySelector('#lrn-dl-t').textContent = h ? h.textContent : '';
      dl.querySelector('.lrn-dl-meta').textContent = (pdf ? 'Gratis · ' : '') + (c.getAttribute('data-meta') || '');

      var list = dl.querySelector('.lrn-dl-list');
      list.innerHTML = '';
      var items = c.querySelectorAll(':scope > ul > li, :scope details li');
      for (var i = 0; i < items.length; i++) list.appendChild(el('li', null, items[i].textContent));
      list.hidden = !items.length;

      var serie = c.getAttribute('data-serie') || '';
      var sp = dl.querySelector('.lrn-dl-serie');
      sp.hidden = !serie;
      if (serie) {
        var parts = serie.split(' · ');
        sp.querySelector('b').textContent = 'Aus der Reihe ' + parts.slice(0, 2).join(' · ');
        sp.querySelector('span').textContent = parts.slice(2).join(' · ');
      }

      dl.querySelector('.lrn-dl-tip').hidden = !pdf;
      go.hidden = !pdf;
      cancel.textContent = pdf ? 'Abbrechen' : 'Schließen';

      var thumbs = (c.getAttribute('data-thumbs') || '').split(/\s+/).filter(Boolean);
      var first = c.querySelector('img');
      pages = thumbs.length ? thumbs : (first ? [first.currentSrc || first.src] : []);
      var vis = c.getAttribute('data-vis') || '';
      img.classList.toggle('is-free', !thumbs.length && /\bfit\b/.test(vis));
      show(0);

      dl.hidden = false;
      lockScroll(true);
      (go.hidden ? dl.querySelector('.lrn-dl-x') : go).focus();
    }

    function close() {
      if (dl.hidden) return;
      dl.hidden = true;
      lockScroll(false);
      if (card) card.focus();
    }

    function download() {
      var pdf = card.getAttribute('data-pdf');
      var name = card.getAttribute('data-download') || '';
      close();
      if (!pdf) return;
      fetch(pdf)
        .then(function (r) { if (!r.ok) throw new Error('fetch'); return r.blob(); })
        .then(function (blob) {
          var a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = name || pdf.split('/').pop().split('?')[0];
          document.body.appendChild(a);
          a.click();
          a.remove();
          setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
          toast(root, 'Gespeichert. Viel Spaß beim Ausdrucken!');
        })
        .catch(function () { window.open(pdf, '_blank', 'noopener'); });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      if (dl.contains(t)) {
        if (t.closest('[data-dl-close]')) close();
        else if (t.closest('.lrn-dl-nav.prev')) show(idx - 1);
        else if (t.closest('.lrn-dl-nav.next')) show(idx + 1);
        else if (t.closest('.lrn-dl-go')) download();
        return;
      }
      var c = t.closest('.lern-karte');
      if (!c || !root.contains(c)) return;
      // Links außer dem PDF (z. B. im Kartentext) bleiben normale Links.
      var a = t.closest('a[href]');
      if (a && a.getAttribute('href') !== c.getAttribute('data-pdf')) return;
      e.preventDefault();
      open(c);
    });

    document.addEventListener('keydown', function (e) {
      if (!dl.hidden) {
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') show(idx - 1);
        else if (e.key === 'ArrowRight') show(idx + 1);
        else if (e.key === 'Tab') trapFocus(e, dl);
        return;
      }
      var c = e.target.classList && e.target.classList.contains('lern-karte') ? e.target : null;
      if (c && root.contains(c) && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); open(c); }
    });

    return dl;
  }

  function trapFocus(e, box) {
    var f = [].filter.call(box.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])'), function (n) {
      return !n.hidden && !n.disabled && n.offsetParent !== null;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ── Story „Lerne Hugo kennen“ ─────────────────────────────────────── */
  function setupStory(root) {
    var src = root.querySelector('.lern-story');
    var folien = src ? src.querySelectorAll('.lern-story-folie') : [];
    if (!folien.length) return;

    var st = el('div', 'lrn-st');
    st.setAttribute('role', 'dialog');
    st.setAttribute('aria-modal', 'true');
    st.setAttribute('aria-label', src.getAttribute('data-label') || 'Story');
    st.hidden = true;

    var bars = '';
    for (var b = 0; b < folien.length; b++) bars += '<i><b></b></i>';
    var hero = root.querySelector('.lrn-art');
    var avatar = hero ? hero.getAttribute('src') : '';
    st.innerHTML =
      '<div class="lrn-st-backdrop" data-st-close></div>' +
      '<button class="lrn-st-arrow lrn-st-prev" type="button" aria-label="Vorherige Folie">' + ICON.prev + '</button>' +
      '<div class="lrn-st-frame">' +
        '<div class="lrn-st-bars">' + bars + '</div>' +
        '<div class="lrn-st-head"><span class="lrn-st-av">' + (avatar ? '<img src="' + avatar + '" alt="">' : '') + '</span>' +
          '<span class="lrn-st-who"><b>Hugo</b><small>happyhug · Lernen</small></span>' +
          '<button class="lrn-st-pause" type="button" aria-pressed="false" aria-label="Pause">' + ICON.pause + ICON.play + '</button>' +
          '<button class="lrn-st-x" type="button" data-st-close aria-label="Schließen">' + ICON.x + '</button></div>' +
        '<div class="lrn-st-slides"></div>' +
        '<button class="lrn-st-zone lrn-st-prev" type="button" aria-label="Zurück" tabindex="-1"></button>' +
        '<button class="lrn-st-zone lrn-st-next" type="button" aria-label="Weiter" tabindex="-1"></button>' +
      '</div>' +
      '<button class="lrn-st-arrow lrn-st-next" type="button" aria-label="Nächste Folie">' + ICON.next + '</button>';

    var box = st.querySelector('.lrn-st-slides');
    for (var i = 0; i < folien.length; i++) box.appendChild(buildSlide(folien[i]));
    root.appendChild(st);
    root.classList.add('lrn-js-story');

    var slides = box.children;
    var barEls = st.querySelectorAll('.lrn-st-bars i');
    var pauseBtn = st.querySelector('.lrn-st-pause');
    var cur = -1;
    var paused = false;
    var opener = null;

    function show(i) {
      if (i < 0) i = 0;
      if (i >= slides.length) { close(); return; }
      cur = i;
      for (var k = 0; k < slides.length; k++) {
        slides[k].hidden = k !== i;
        barEls[k].className = k < i ? 'done' : '';
      }
      var bar = barEls[i];
      void bar.offsetWidth;
      bar.style.setProperty('--d', (parseFloat(slides[i].getAttribute('data-dur')) || 5) + 's');
      bar.className = 'run' + (paused ? ' hold' : '');
    }

    function setPaused(on) {
      paused = on;
      var bar = barEls[cur];
      if (bar && bar.className.indexOf('run') === 0) bar.className = 'run' + (on ? ' hold' : '');
      pauseBtn.setAttribute('aria-pressed', String(on));
      pauseBtn.setAttribute('aria-label', on ? 'Weiter abspielen' : 'Pause');
    }

    function open(trigger) {
      opener = trigger;
      // Bilder der Folien erst jetzt laden (im Body liegen sie lazy).
      var imgs = st.querySelectorAll('img[data-src]');
      for (var n = 0; n < imgs.length; n++) { imgs[n].src = imgs[n].getAttribute('data-src'); imgs[n].removeAttribute('data-src'); }
      st.hidden = false;
      lockScroll(true);
      setPaused(reduceMotion);
      show(0);
      st.querySelector('.lrn-st-x').focus();
    }

    function close() {
      if (st.hidden) return;
      st.hidden = true;
      cur = -1;
      lockScroll(false);
      if (opener) opener.focus();
    }

    for (var j = 0; j < barEls.length; j++) {
      barEls[j].addEventListener('animationend', function () { if (!paused && cur < slides.length - 1) show(cur + 1); });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      var trigger = t.closest('.lrn-play, a[href="#lrn-story"]');
      if (trigger) { e.preventDefault(); open(trigger); return; }
      if (st.hidden || !st.contains(t)) return;
      var a = t.closest('a[href]');
      if (a) {
        // „Mehr entdecken“ zeigt auf diese Seite: Story schließen statt neu laden.
        if (a.pathname === location.pathname) { e.preventDefault(); close(); window.scrollTo(0, 0); }
        return;
      }
      if (t.closest('[data-st-close]')) close();
      else if (t.closest('.lrn-st-pause')) setPaused(!paused);
      else if (t.closest('.lrn-st-prev')) show(cur - 1);
      else if (t.closest('.lrn-st-next')) show(cur + 1);
    });

    document.addEventListener('keydown', function (e) {
      if (st.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(cur + 1);
      else if (e.key === 'ArrowLeft') show(cur - 1);
      else if (e.key === ' ' && !(e.target.closest && e.target.closest('a, button'))) { e.preventDefault(); setPaused(!paused); }
      else if (e.key === 'Tab') trapFocus(e, st);
    });
  }

  // Folie aus dem Body (<p><img></p> <p><em>…</em></p> <p><strong>…</strong></p> <p>…</p> <p><a></a></p>)
  // in die Prototyp-Struktur (.st-slide mit Figur, Text, CTA) übersetzen.
  function buildSlide(f) {
    var s = el('div', 'lrn-st-slide');
    s.hidden = true;
    s.setAttribute('data-dur', f.getAttribute('data-dauer') || '5');
    var bg = f.getAttribute('data-hintergrund');
    if (bg && /^#[0-9a-fA-F]{3,8}$/.test(bg)) s.style.background = bg;
    var bild = f.getAttribute('data-bild') || '';
    var cover = f.hasAttribute('data-cover');
    if (cover) s.classList.add('is-cover');

    var txt = el('div', 'lrn-st-txt');
    var cta = null;
    var ps = f.children;
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      var imgs = p.querySelectorAll('img');
      if (imgs.length > 1) {
        var grid = el('div', 'lrn-st-patches');
        for (var k = 0; k < imgs.length; k++) grid.appendChild(lazyClone(imgs[k]));
        s.appendChild(grid);
      } else if (imgs.length === 1) {
        var im = lazyClone(imgs[0]);
        im.className = cover ? 'lrn-st-cover' : 'lrn-st-fig ' + bild.replace(/\bst-fig\b/, '').trim();
        s.appendChild(im);
      } else if (p.querySelector('a')) {
        cta = el('div', 'lrn-st-cta');
        var a = p.querySelector('a').cloneNode(true);
        a.className = 'lrn-btn';
        cta.appendChild(a);
      } else if (p.querySelector('strong')) {
        txt.appendChild(el('b', null, p.textContent.trim()));
      } else if (p.querySelector('em')) {
        txt.appendChild(el('small', null, p.textContent.trim()));
      } else if (p.textContent.trim()) {
        txt.appendChild(el('span', null, p.textContent.trim()));
      }
    }
    s.appendChild(txt);
    if (cta) s.appendChild(cta);
    return s;
  }

  function lazyClone(img) {
    var n = document.createElement('img');
    n.setAttribute('data-src', img.currentSrc || img.getAttribute('src'));
    n.alt = img.getAttribute('alt') || '';
    n.decoding = 'async';
    return n;
  }

  /* ── „Auf dieser Seite“ (Guides) ───────────────────────────────────── */
  function setupToc(root) {
    var nav = root.querySelector('[data-lrn-toc]');
    if (!nav) return;
    var body = nav.parentNode.querySelector('.lrn-body');
    var hs = body ? body.querySelectorAll(':scope > h2') : [];
    if (hs.length < 2) return;
    var links = [];
    for (var i = 0; i < hs.length; i++) {
      var h = hs[i];
      if (!h.id) h.id = 'lrn-' + (slug(h.textContent) || 'abschnitt-' + (i + 1));
      var a = el('a', null, h.textContent.trim());
      a.href = '#' + h.id;
      nav.appendChild(a);
      links.push(a);
    }
    nav.hidden = false;
    function mark(i) { for (var k = 0; k < links.length; k++) links[k].classList.toggle('is-on', k === i); }
    mark(0);
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function () {
      var at = 0;
      for (var k = 0; k < hs.length; k++) if (hs[k].getBoundingClientRect().top < 160) at = k;
      mark(at);
    }, { rootMargin: '-120px 0px -60% 0px', threshold: [0, 1] });
    for (var j = 0; j < hs.length; j++) io.observe(hs[j]);
  }

  function slug(s) {
    return s.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* ── Kita-Paket: „<strong>T</strong> · Unterzeile · <em>Hebel</em>“ gliedern ── */
  function setupPaket(root) {
    var lis = root.querySelectorAll('.lern-paket li');
    for (var i = 0; i < lis.length; i++) {
      var li = lis[i];
      var title = li.querySelector('strong');
      if (!title) continue;
      var tags = el('span', 'lrn-pk-tags');
      var sub = [];
      var nodes = [].slice.call(li.childNodes);
      for (var k = 0; k < nodes.length; k++) {
        var n = nodes[k];
        if (n === title) continue;
        if (n.nodeType === 1 && n.tagName === 'EM') tags.appendChild(n);
        else if (n.nodeType === 3) { var t = n.textContent.replace(/·/g, ' ').trim(); if (t) sub.push(t); li.removeChild(n); }
      }
      var tx = el('span', 'lrn-pk-tx');
      tx.appendChild(title);
      if (sub.length) tx.appendChild(el('small', null, sub.join(' · ')));
      li.innerHTML = '';
      li.appendChild(tx);
      if (tags.childNodes.length) li.appendChild(tags);
      li.classList.add('lrn-pk');
    }
  }

  /* ── Filter ────────────────────────────────────────────────────────── */
  function setupFilter(root, cards) {
    var bar = root.querySelector('[data-lrn-filter]');
    if (!bar || !cards.length) return;
    bar.hidden = false;
    var input = bar.querySelector('[data-lrn-q]');
    var count = bar.querySelector('[data-lrn-count]');
    var resetBtn = bar.querySelector('.lrn-fb-reset');
    var empty = root.querySelector('[data-lrn-empty]');
    var words = [];
    for (var w = 0; w < cards.length; w++) words.push((cards[w].textContent || '').toLowerCase());

    function apply() {
      var q = input.value.trim().toLowerCase();
      var hebel = [].map.call(bar.querySelectorAll('[data-f-hebel][aria-pressed="true"]'), function (b) { return b.getAttribute('data-f-hebel'); });
      var ageBtn = bar.querySelector('[data-f-age][aria-pressed="true"]');
      var age = ageBtn ? ageBtn.getAttribute('data-f-age') : '';
      var shown = 0;
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        var h = (c.getAttribute('data-hebel') || '').split(' ');
        var a = (c.getAttribute('data-ages') || '').split(' ');
        var ok = (!q || words[i].indexOf(q) > -1)
          && hebel.every(function (k) { return h.indexOf(k) > -1; })
          && (!age || a.indexOf(age) > -1);
        c.hidden = !ok;
        if (ok) shown++;
      }
      count.textContent = shown === 1 ? '1 Idee' : shown + ' Ideen';
      resetBtn.hidden = !(q || hebel.length || age);
      if (empty) empty.hidden = shown > 0;
    }

    function reset() {
      input.value = '';
      var on = bar.querySelectorAll('[aria-pressed="true"]');
      for (var i = 0; i < on.length; i++) on[i].setAttribute('aria-pressed', 'false');
      apply();
    }

    input.addEventListener('input', apply);
    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      var chip = t.closest('[data-f-hebel], [data-f-age]');
      if (chip && bar.contains(chip)) {
        var turnOn = chip.getAttribute('aria-pressed') !== 'true';
        if (chip.hasAttribute('data-f-age')) {
          var others = bar.querySelectorAll('[data-f-age]');
          for (var i = 0; i < others.length; i++) others[i].setAttribute('aria-pressed', 'false');
        }
        chip.setAttribute('aria-pressed', String(turnOn));
        apply();
        return;
      }
      if (t.closest('[data-lrn-reset]')) reset();
    });
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
